<template>
  <div>
    <van-tabs v-model="activeName" sticky>
      <van-tab title="课程详情" name="1">
        <ClassDetials :classDetial="classDetial" />
      </van-tab>
      <van-tab title="课程目录" name="2">
        <ClassCata />
      </van-tab>
      <van-tab title="课程讲师" name="3">
        <Teacher />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Teacher from "@/components/class/classtabs/teacher";
import ClassDetials from "@/components/class/classtabs/classDetials";
import ClassCata from "@/components/class/classtabs/classCata";

export default {
  props:{
    classDetial:{
      type:Object,
      default:() => {
        return {}
      }
    }
  },
  components: {
    Teacher,ClassDetials,ClassCata
  },
  data() {
    return {
      activeName: "1",
      
    };
  },
  
};
</script>

<style scoped lang="less">
/deep/ .van-tab--active {
  font-size: 0.9rem;
  font-weight: 800;
}
/deep/ .van-tabs__line {
  display: none;
}
</style>